
export default class CarouselItemElement extends HTMLElement {
    constructor(){
        super();
    }
}

customElements.define('carousel-item', CarouselItemElement);